export const importAllImages = (r) => {
	const imgArray = r.keys().map(r);
	const keys = r.keys();
	const imgObj = {};
	for (let i = 0; i < keys.length; i++) {
		let key = keys[i].split('/')[1];
		imgObj[key] = imgArray[i];
	}
	return imgObj;
};